import React from 'react';

import { svg } from '../assets/svg';
import { hooks } from '../hooks';
import { Routes, TabScreens } from '../routes';
import { getItemFromLocalStorage } from '../utils/getItemFromLocalStorage';

const tabs = [
  {
    id: 1,
    screen: TabScreens.Home,
    icon: <svg.HomeTabSvg />,
    url:Routes.TabNavigator
  },
  {
    id: 2,
    screen: TabScreens.Menu,
    icon: <svg.SearchTabSvg />,
    url:Routes.Menu

  },
  {
    id: 3,
    screen: TabScreens.Order,
    icon: <svg.OrderTabSvg />,
    url:Routes.Order

  },
  {
    id: 4,
    screen: TabScreens.Favorite,
    icon: <svg.HeartTabSvg />,
    url:Routes.Favorite

  },
  {
    id: 5,
    screen: TabScreens.Notification,
    icon: <svg.BellTabSvg />,
    url:Routes.Notification

  },
];

export const Footer: React.FC = () => {
  const navigate = hooks.useNavigate();
  const location = hooks.useLocation();
  const MENU_CONFIG = getItemFromLocalStorage("menuConfiguration");
  
  const filteredTabs = MENU_CONFIG?.isOrderFromAppSupported
    ? tabs.filter((tab) => [1, 2, 3, 4, 5].includes(tab.id))
    : tabs.filter((tab) => [1, 3].includes(tab.id));

  const isActiveTab = (tabUrl: string): boolean => {
    const currentPath = location.pathname;
    if (tabUrl === Routes.TabNavigator) {
      return currentPath === Routes.TabNavigator || currentPath === '/';
    }
    return currentPath === tabUrl || currentPath.startsWith(tabUrl + '/');
  };

  return (
    <section
      style={{
        padding: 0,
        paddingTop: 0,
        paddingBottom: 0,
        position: 'relative',
      }}
    >
      <footer
        style={{
          zIndex: 100,
          borderRadius: '20px 20px 0 0',
          height: 'var(--footer-height)',
          backgroundColor: 'var(--white-color)',
          boxShadow: '0 -2px 12px rgba(0, 0, 0, 0.06)',
          borderTop: '1px solid rgba(0, 0, 0, 0.05)',
        }}
      >
        <ul
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            margin: 0,
            padding: 0,
            listStyle: 'none',
          }}
        >
          {filteredTabs.map((tab) => {
            const isActive = isActiveTab(tab.url);
            
            return (
              <li
                key={tab.id}
                className='clickable center'
                style={{
                  height: '100%',
                  width: `calc(100% / ${filteredTabs.length})`,
                  borderRadius: 10,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 4,
                  position: 'relative',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  navigate(tab.url);
                }}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.backgroundColor = 'rgba(0, 176, 185, 0.05)';
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: isActive ? 'var(--main-turquoise)' : 'var(--text-color)',
                    transition: 'all 0.2s ease',
                    transform: isActive ? 'scale(1.1)' : 'scale(1)',
                  }}
                >
                  {tab.icon}
                </div>
                {isActive && (
                  <div
                    style={{
                      position: 'absolute',
                      bottom: 8,
                      width: 4,
                      height: 4,
                      borderRadius: '50%',
                      backgroundColor: 'var(--main-turquoise)',
                      boxShadow: '0 0 8px rgba(0, 176, 185, 0.6)',
                    }}
                  />
                )}
              </li>
            );
          })}
        </ul>
      </footer>
    </section>
  );
};
